export default __webpack_public_path__ + "contentmodules/CTM_MasterScorecard.bb860524.png";